var login =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var evalAllowed = false;
try {
  eval('evalAllowed = true');
} catch (e) {
  // eval not allowed due to CSP
}

// RHL needs setPrototypeOf to operate Component inheritance, and eval to patch methods
var platformSupported = !!Object.setPrototypeOf && evalAllowed;

if (true) {
  if (false) {
    // we are not in prod mode, but RHL could not be activated
    console.warn('React-Hot-Loaded is not supported in this environment');
  }
  module.exports = __webpack_require__(3);
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2)),classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},AppContainer=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,e.apply(this,arguments))}return inherits(t,e),t.prototype.render=function(){return React.Children.only(this.props.children)},t}(React.Component),hot_prod=function(){return function(e){return e}},areComponentsEqual=function(e,t){return e===t},setConfig=function(){},cold=function(e){return e},configureComponent=function(){};exports.AppContainer=AppContainer,exports.hot=hot_prod,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig,exports.cold=cold,exports.configureComponent=configureComponent;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

var starbucks = function starbucks() {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = 'https://gw.alicdn.com/tfs/TB1aUVAr.OWBKNjSZKzXXXfWFXa-182-182.png';
    document.getElementsByTagName('head')[0].appendChild(link);
    document.title = '星巴克中国';
};

var _default = starbucks;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(starbucks, 'starbucks', '/cloud/source_code/src/starbucks.js');
    reactHotLoader.register(_default, 'default', '/cloud/source_code/src/starbucks.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)(module)))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

var appName = 'xspace-bss';
var msgMap = {};
if (window.g_resource && window.g_resource[appName] && window.g_resource[appName].messages) {
  var messages = window.g_resource[appName].messages;
  for (var k in messages) {
    msgMap['xspace.client.' + k] = messages[k];
  }
}

var _default = function _default(prefix, key, params) {
  var resultMsg = msgMap['xspace.client.' + appName + '.' + prefix + '.' + key];
  if (params && resultMsg && resultMsg.indexOf('{') > -1) {
    for (var _k in params) {
      resultMsg = resultMsg.replace('{' + _k + '}', params[_k]);
    }
  }
  if (!resultMsg) {
    return key;
  }
  return resultMsg;
};

/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(appName, 'appName', '/cloud/source_code/src/i18n/index.js');
  reactHotLoader.register(msgMap, 'msgMap', '/cloud/source_code/src/i18n/index.js');
  reactHotLoader.register(_default, 'default', '/cloud/source_code/src/i18n/index.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)(module)))

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {(function () {
  var enterModule = __webpack_require__(0).enterModule;

  enterModule && enterModule(module);
})();

/**
 * 通用工具函数
 */

var util = {
  getDefaultLang: function getDefaultLang() {
    var defaultLang = window.navigator.language;
    // 做多语言标识符适配
    if (defaultLang && defaultLang.split('-')[0] === 'zh') {
      defaultLang = 'zh-CN';
    } else if (defaultLang && defaultLang.split('-')[0] === 'en') {
      defaultLang = 'en-US';
    } else {
      // 除了设置为中文系外，其它的默认都是英文
      defaultLang = 'en-US';
    }
    return defaultLang;
  },
  getParamFromUrl: function getParamFromUrl(paramKey) {
    var params = location.search.slice(1).split('&');
    var paramsObj = {};
    params.map(function (param) {
      paramsObj[param.split('=')[0]] = param.split('=')[1];
    });
    return paramsObj[paramKey];
  },

  requestErrorHandle: function requestErrorHandle(error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  },

  /**
   * 邮箱验证(当输入为空时要通过验证，非空验证逻辑要拆出来)
   * @param str
   * @returns {boolean}
   */
  isEmail: function isEmail(str) {
    if (typeof str !== 'string') {
      return false;
    }
    var reg = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return reg.test(str.trim());
  },


  /**
   * 电话验证，这里只做是不是11为数字的验证(当输入为空时要通过验证，非空验证逻辑要拆出来)
   * @param tel
   * @returns {boolean}
   */
  isTel: function isTel(tel) {
    if (typeof tel === 'undefined') {
      return false;
    }
    if (typeof tel === 'string') {
      tel = tel.trim();
    }
    var reg = /^\d{11}$/;
    return reg.test(tel);
  },

  /**
   * 取cookie
   * @param {string} cname
   */
  getCookie: function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }
};

var _default = util;
/* harmony default export */ __webpack_exports__["a"] = (_default);
;

(function () {
  var reactHotLoader = __webpack_require__(0).default;

  var leaveModule = __webpack_require__(0).leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(util, 'util', '/cloud/source_code/src/utils.js');
  reactHotLoader.register(_default, 'default', '/cloud/source_code/src/utils.js');
  leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ali_xspace_login_widget__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ali_xspace_login_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ali_xspace_login_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__starbucks__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__app_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

(function () {
    var enterModule = __webpack_require__(0).enterModule;

    enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Login = function (_Component) {
    _inherits(Login, _Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        _this.state = {
            loading: true
        };

        _this.isStar = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getParamFromUrl('from') === 'starbucks';

        if (_this.isStar) Object(__WEBPACK_IMPORTED_MODULE_3__starbucks__["a" /* default */])();
        return _this;
    }

    _createClass(Login, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            var thirdLoginTypes = [];
            var isShowPhoneEmailLogin = false;

            var from = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getParamFromUrl('from');

            var isFR = false;
            var redirectPath = '/alime.htm';
            if (location.pathname === '/login/loginWithAutoClose.htm') {
                isFR = true;
                redirectPath = '/login/loginWithAutoClose.htm?autoClose=true';
            }

            if (window.g_config && window.g_config.thirdLoginTypes) {

                thirdLoginTypes = window.g_config.thirdLoginTypes;
            }

            if (window.g_config && window.g_config.isShowPhoneEmailLogin) {
                isShowPhoneEmailLogin = window.g_config.isShowPhoneEmailLogin;
            }
            var loginEmbedder = new __WEBPACK_IMPORTED_MODULE_2__ali_xspace_login_widget___default.a();
            loginEmbedder.render('login-frame-container', {
                theme: window.g_config.showOpenAccount ? 'bright' : 'dark',
                platformForm: from,
                ssoKey: '5512',
                lang: __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getDefaultLang(),
                redirectUrl: window.location.protocol + '//' + window.location.host + redirectPath,
                width: window.g_config.showOpenAccount ? 330 : 380,
                height: window.g_config.showOpenAccount ? 230 : 280,
                supportUicAccount: !window.g_config.showOpenAccount,
                uicAccountConfig: {
                    isFullRedirect: isFR
                },
                supportBucAccount: thirdLoginTypes.indexOf('buc') > -1,
                bucAccountConfig: {},
                supportOpenAccount: window.g_config.showOpenAccount,
                openAccountConfig: window.g_config.openAccountConfig,
                supportEmailPhoneLogin: isShowPhoneEmailLogin
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var alimeLoginImg = {
                url: '//gw.alicdn.com/tfs/TB1MIztkYuWBuNjSszgXXb8jVXa-2560-1440.jpg',
                text1: '尖叫，从对话开始',
                text2: 'Scream, start from conversation',
                logo: 'AlimeBot Platform'
            };

            var starbucksImg = {
                url: 'https://gw.alicdn.com/tfs/TB1cpItr5MnBKNjSZFCXXX0KFXa-1440-800.png',
                text1: '每人，每杯，每个社区',
                text2: 'Everyone, every cup, every community',
                logo: '星巴克中国'
            };
            var loadAssets = this.isStar ? starbucksImg : alimeLoginImg;
            var loading = this.state.loading;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'alime-container' },
                this.isStar ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'i',
                    { className: 'alime-logo-star' },
                    loadAssets.logo
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'i',
                    { className: 'alime-logo' },
                    loadAssets.logo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()({
                        'alime-login-iframe': true,
                        'open-account-login-style': window.g_config.showOpenAccount
                    }), id: 'login-frame-container' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'login-background' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'carousel-item', style: { backgroundImage: 'url(' + loadAssets.url + ')' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'carousel-text' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { className: 't1' },
                                loadAssets.text1
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { className: 't2' },
                                loadAssets.text2
                            )
                        )
                    )
                ),
                this.isStar ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Copyright \xA9 2018 ',
                    '阿里巴巴 智能服务事业部'
                )
            );
        }
    }, {
        key: '__reactstandin__regenerateByEval',
        // @ts-ignore
        value: function __reactstandin__regenerateByEval(key, code) {
            // @ts-ignore
            this[key] = eval(code);
        }
    }]);

    return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Login, null), document.getElementById('root'));
;

(function () {
    var reactHotLoader = __webpack_require__(0).default;

    var leaveModule = __webpack_require__(0).leaveModule;

    if (!reactHotLoader) {
        return;
    }

    reactHotLoader.register(Login, 'Login', '/cloud/source_code/src/app.js');
    leaveModule(module);
})();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.XSpaceLoginEmbedder=n():e.XSpaceLoginEmbedder=n()}(window,function(){return function(e){var n={};function o(t){if(n[t])return n[t].exports;var r=n[t]={i:t,l:!1,exports:{}};return e[t].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=e,o.c=n,o.d=function(e,n,t){o.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:t})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,n){if(1&n&&(e=o(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)o.d(t,r,function(n){return e[n]}.bind(null,r));return t},o.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(n,"a",n),n},o.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},o.p="/",o(o.s=8)}([function(e,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var t=function(){function e(e,n){for(var o=0;o<n.length;o++){var t=n[o];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}return function(n,o,t){return o&&e(n.prototype,o),t&&e(n,t),n}}(),r=l(o(1)),a=l(o(2)),i=l(o(3));function l(e){return e&&e.__esModule?e:{default:e}}function c(e,n,o){return n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e}o(4);var s=function(){function e(){!function(e,n){if(!(e instanceof n))throw new TypeError("Cannot call a class as a function")}(this,e)}return t(e,[{key:"getOAScript",value:function(e){var n=document.createElement("script");n.type="text/javascript",n.src="//g.alicdn.com/vip/open-account/0.3.10/js/mini-login-embedderV3.js",n.charset="utf-8",n.onload=e,n.onerror=function(){console.error("[xspace-login-widget]加载OA JSSDK失败")},document.body.appendChild(n)}},{key:"getBucEntryTemplate",value:function(e,n){return e?'\n        <li class="entry-item">\n          <i class="iconfont alibaba">&#xe93a;</i>\n          <a class="entry-link" target="_self" href="/login/bucSSO.htm">'+(0,i.default)("bucEntryName",n)+"</a>\n        </li>\n      ":""}},{key:"getEmailPhoneEntryTemplate",value:function(e,n){return e?'\n        <li class="entry-item">\n          <i class="iconfont email">&#xe6b4;</i>\n          <a class="entry-link" target="_blank" href="/emailSMSLogin.htm">'+(0,i.default)("emailPhoneEntryName",n)+"</a>\n        </li>\n      ":""}},{key:"render",value:function(e,n){var o=this,t=n.platformFrom,i=void 0===t?"xspace":t,l=n.theme,s=void 0===l?"bright":l,f=n.redirectUrl,p=void 0===f?"":f,u=n.width,m=void 0===u?380:u,g=n.height,d=void 0===g?280:g,h=n.lang,x=void 0===h?window.navigator.language||"zh-CN":h,y="boolean"!=typeof n.supportUicAccount||n.supportUicAccount,v="boolean"==typeof n.supportBucAccount&&n.supportBucAccount,b="boolean"==typeof n.supportOpenAccount&&n.supportOpenAccount,w="boolean"==typeof n.supportEmailPhoneLogin&&n.supportEmailPhoneLogin;if("string"!=typeof document.getElementById(e))if(b&&y)console.error("[xspace-login-widget]不能同时开启supportUicAccount和supportOpenAccount");else if(["bright","dark"].indexOf(s)<=-1)console.error("[xspace-login-widght]主题配置theme值只能是bright或dark");else if(b)this.getOAScript(function(){var t=n.openAccountConfig,i=void 0===t?{}:t,l='\n          <div class="'+(0,r.default)(c({"xspace-login-frame":!0,"open-accout":!0},s,!0))+'" style="width: '+m+'px">\n            <div id="alibaba-openaccount-iframe-container"></div>\n            <ul class="other-login-entry">\n              '+o.getBucEntryTemplate(v,x)+"\n              "+o.getEmailPhoneEntryTemplate(w,x)+"\n            </ul>\n          </div>\n        ";document.getElementById(e).innerHTML=l,(0,a.default)("alibaba-openaccount-iframe-container",i,n)});else{var j=n.uicAccountConfig,k=(void 0===j?{}:j).isFullRedirect,E=void 0===k||k,L=void 0;"bright"===s?L="auto":"dark"===s&&(L="XSpace");var U="//login.taobao.com";-1!==location.hostname.indexOf("daily.taobao.net")&&(U="//login.daily.taobao.net");var _=U+"?newMini2=true&lang="+x.replace("-","_")+"&sub=true&sub_jump=current&style=mini&css_style="+L+"&from="+i+"&full_redirect="+E+"&redirectURL="+encodeURIComponent(p),S='\n        <div class="'+(0,r.default)(c({"xspace-login-frame":!0,"uic-account":!0},s,!0))+'" style="width: '+m+'px">\n          <iframe src="'+_+'" scrolling="no" frameBorder="0" width="'+m+'" height="'+d+'"></iframe>\n          <ul class="other-login-entry">\n            '+this.getBucEntryTemplate(v,x)+"\n            "+this.getEmailPhoneEntryTemplate(w,x)+"\n          </ul>\n        </div>\n      ";document.getElementById(e).innerHTML=S}else console.error("[xspace-login-widget]传入的container无法找到对应的DOM节点")}}]),e}();n.default=s},function(e,n,o){var t;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/!function(){"use strict";var o={}.hasOwnProperty;function r(){for(var e=[],n=0;n<arguments.length;n++){var t=arguments[n];if(t){var a=typeof t;if("string"===a||"number"===a)e.push(t);else if(Array.isArray(t)&&t.length){var i=r.apply(null,t);i&&e.push(i)}else if("object"===a)for(var l in t)o.call(t,l)&&t[l]&&e.push(l)}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):void 0===(t=function(){return r}.apply(n,[]))||(e.exports=t)}()},function(e,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.default=function(e,n,o){var t=o.platformFrom,r=void 0===t?"xspace":t,a=o.redirectUrl,i=void 0===a?"":a,l=o.ssoKey,c=void 0===l?"":l,s=o.width,f=void 0===s?380:s,p=o.height,u=void 0===p?280:p,m=o.lang,g=void 0===m?(window.navigator.language||"zh-CN").replace("-","_"):m,d=n.oaLoginDomainHost,h=new window.MiniLoginEmbedder,x=n.appKey,y=void 0===x?"60039810":x,v=n.addRegisterUrl,b=void 0===v||v,w=n.addRegisterCustomUrl,j=n.addSwitchUrl,k=void 0===j||j,E=n.addResetPwdUrl,L=void 0===E||E,U=n.addResetPwdCustomUrl,_=n.useQrcodeLogin,S=void 0===_||_,C=n.useQrcodeFirst,O=void 0!==C&&C;h.addEvent("onMessage",function(e){e.action&&"loginResult"===e.action&&"100"===e.resultCode&&(location.href="/login/redirectedPage.htm?type=oa&token="+encodeURIComponent(e.token)+"&loginId="+e.loginId+"&redirectURL="+encodeURIComponent(i)+"&ssoKey="+c),e.action&&"register"===e.action&&"100"===e.resultCode&&window.open(w||"register.htm?from="+r),e.action&&"resetpwd"===e.action&&"100"===e.resultCode&&window.open(U||"findPwd.htm?from="+r)}),h.init({targetId:e,appKey:y,iframeUrl:"https://"+d+"/login/mini_login.htm",lang:g,notLoadSsoView:"",notKeepLogin:"true",loginId:"",styleType:"auto",iframeHeight:u,iframeWidth:f,autotest:"false",addRegisterUrl:b.toString(),addSwitchUrl:k.toString(),addResetPwdUrl:L.toString(),useQrcodeLogin:S.toString(),useQrcodeFirst:O.toString()})}},function(e,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var t={bucEntryName:{"en-us":"Domain Account","zh-cn":"域账号登录","ar-sa":"حساب نطاق","fr-fr":"Compte de domaine","ru-ru":"Учетная запись домена посадки","es-es":"Cuenta de dominio de aterrizaje","th-th":"Domain บัญชี landing","ms-my":"Domain login akaun","vi-vn":"Miền tài khoản hạ cánh","in-id":"Akun Domain landing"},emailPhoneEntryName:{"en-us":"Email or Phone Login","zh-cn":"手机邮箱登录","ar-sa":"البريد الإلكتروني أو الهاتف الدخول","fr-fr":"E-mail ou Téléphone Connexion","ru-ru":"Мобильный телефон почта посадки","es-es":"Correo móvil aterrizaje","th-th":"เข้าสู่ระบบโทรศัพท์มือถือ","ms-my":"Telefon Masuk E-mel","vi-vn":"မိုဘိုင်း E-mail ကိုဝင်မည်","in-id":"Login ponsel"}};n.default=function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"zh-cn";return t[e]?t[e][n.toLocaleLowerCase()]:""}},function(e,n,o){var t=o(5);"string"==typeof t&&(t=[[e.i,t,""]]),o(7)(t,{}),t.locals&&(e.exports=t.locals)},function(e,n,o){(e.exports=o(6)()).push([e.i,"@font-face {\n  font-family: 'xspace-login-iconfont';\n  /* project id 1012590 */\n  src: url('//at.alicdn.com/t/font_1012590_68hrhy9meja.eot');\n  src: url('//at.alicdn.com/t/font_1012590_68hrhy9meja.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_1012590_68hrhy9meja.woff2') format('woff2'), url('//at.alicdn.com/t/font_1012590_68hrhy9meja.woff') format('woff'), url('//at.alicdn.com/t/font_1012590_68hrhy9meja.ttf') format('truetype'), url('//at.alicdn.com/t/font_1012590_68hrhy9meja.svg#iconfont') format('svg');\n}\n.iconfont {\n  font-family: \"xspace-login-iconfont\" !important;\n  font-size: 12px;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.xspace-login-frame {\n  /* css reset */\n  /* http://meyerweb.com/eric/tools/css/reset/\n    v2.0 | 20110126\n    License: none (public domain)\n  */\n  /* HTML5 display-role reset for older browsers */\n  /* 其它登陆方式列表区域 */\n  /* 亮色系主题 */\n  /* 暗色系主题 */\n}\n.xspace-login-frame html,\n.xspace-login-frame body,\n.xspace-login-frame div,\n.xspace-login-frame span,\n.xspace-login-frame applet,\n.xspace-login-frame object,\n.xspace-login-frame iframe,\n.xspace-login-frame h1,\n.xspace-login-frame h2,\n.xspace-login-frame h3,\n.xspace-login-frame h4,\n.xspace-login-frame h5,\n.xspace-login-frame h6,\n.xspace-login-frame p,\n.xspace-login-frame blockquote,\n.xspace-login-frame pre,\n.xspace-login-frame a,\n.xspace-login-frame abbr,\n.xspace-login-frame acronym,\n.xspace-login-frame address,\n.xspace-login-frame big,\n.xspace-login-frame cite,\n.xspace-login-frame code,\n.xspace-login-frame del,\n.xspace-login-frame dfn,\n.xspace-login-frame em,\n.xspace-login-frame img,\n.xspace-login-frame ins,\n.xspace-login-frame kbd,\n.xspace-login-frame q,\n.xspace-login-frame s,\n.xspace-login-frame samp,\n.xspace-login-frame small,\n.xspace-login-frame strike,\n.xspace-login-frame strong,\n.xspace-login-frame sub,\n.xspace-login-frame sup,\n.xspace-login-frame tt,\n.xspace-login-frame var,\n.xspace-login-frame b,\n.xspace-login-frame u,\n.xspace-login-frame i,\n.xspace-login-frame center,\n.xspace-login-frame dl,\n.xspace-login-frame dt,\n.xspace-login-frame dd,\n.xspace-login-frame ol,\n.xspace-login-frame ul,\n.xspace-login-frame li,\n.xspace-login-frame fieldset,\n.xspace-login-frame form,\n.xspace-login-frame label,\n.xspace-login-frame legend,\n.xspace-login-frame table,\n.xspace-login-frame caption,\n.xspace-login-frame tbody,\n.xspace-login-frame tfoot,\n.xspace-login-frame thead,\n.xspace-login-frame tr,\n.xspace-login-frame th,\n.xspace-login-frame td,\n.xspace-login-frame article,\n.xspace-login-frame aside,\n.xspace-login-frame canvas,\n.xspace-login-frame details,\n.xspace-login-frame embed,\n.xspace-login-frame figure,\n.xspace-login-frame figcaption,\n.xspace-login-frame footer,\n.xspace-login-frame header,\n.xspace-login-frame hgroup,\n.xspace-login-frame menu,\n.xspace-login-frame nav,\n.xspace-login-frame output,\n.xspace-login-frame ruby,\n.xspace-login-frame section,\n.xspace-login-frame summary,\n.xspace-login-frame time,\n.xspace-login-frame mark,\n.xspace-login-frame audio,\n.xspace-login-frame video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n.xspace-login-frame article,\n.xspace-login-frame aside,\n.xspace-login-frame details,\n.xspace-login-frame figcaption,\n.xspace-login-frame figure,\n.xspace-login-frame footer,\n.xspace-login-frame header,\n.xspace-login-frame hgroup,\n.xspace-login-frame menu,\n.xspace-login-frame nav,\n.xspace-login-frame section {\n  display: block;\n}\n.xspace-login-frame body {\n  line-height: 1;\n}\n.xspace-login-frame ol,\n.xspace-login-frame ul {\n  list-style: none;\n}\n.xspace-login-frame blockquote,\n.xspace-login-frame q {\n  quotes: none;\n}\n.xspace-login-frame blockquote:before,\n.xspace-login-frame blockquote:after,\n.xspace-login-frame q:before,\n.xspace-login-frame q:after {\n  content: '';\n  content: none;\n}\n.xspace-login-frame table {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.xspace-login-frame.uic-account {\n  min-height: 310px;\n}\n.xspace-login-frame.uic-account iframe {\n  min-height: 310px;\n}\n.xspace-login-frame.uic-account .other-login-entry {\n  margin-left: 25px;\n}\n.xspace-login-frame.open-account .other-login-entry {\n  margin-left: 0;\n}\n.xspace-login-frame .other-login-entry {\n  padding-bottom: 20px;\n  line-height: 28px;\n}\n.xspace-login-frame .other-login-entry li.entry-item {\n  display: inline-block;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.xspace-login-frame .other-login-entry li.entry-item .iconfont {\n  border-radius: 25px;\n  font-size: 18px;\n  vertical-align: middle;\n}\n.xspace-login-frame .other-login-entry li.entry-item .iconfont svg {\n  margin-bottom: -3px;\n}\n.xspace-login-frame .other-login-entry .entry-link {\n  font-size: 13px;\n  text-decoration: none;\n}\n.xspace-login-frame.bright {\n  background: #ffffff;\n}\n.xspace-login-frame.bright .other-login-entry .iconfont.alibaba {\n  color: #ff4400;\n}\n.xspace-login-frame.bright .other-login-entry .iconfont.email {\n  color: #6c6c6c;\n}\n.xspace-login-frame.bright .other-login-entry .entry-link {\n  color: #6c6c6c;\n}\n.xspace-login-frame.dark {\n  background: rgba(0, 0, 0, 0.6);\n}\n.xspace-login-frame.dark .other-login-entry .iconfont.alibaba {\n  color: #ff4400;\n}\n.xspace-login-frame.dark .other-login-entry .iconfont.email {\n  color: #fff;\n}\n.xspace-login-frame.dark .other-login-entry .entry-link {\n  color: #fff;\n}\n",""])},function(e,n){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],n=0;n<this.length;n++){var o=this[n];o[2]?e.push("@media "+o[2]+"{"+o[1]+"}"):e.push(o[1])}return e.join("")},e.i=function(n,o){"string"==typeof n&&(n=[[null,n,""]]);for(var t={},r=0;r<this.length;r++){var a=this[r][0];"number"==typeof a&&(t[a]=!0)}for(r=0;r<n.length;r++){var i=n[r];"number"==typeof i[0]&&t[i[0]]||(o&&!i[2]?i[2]=o:o&&(i[2]="("+i[2]+") and ("+o+")"),e.push(i))}},e}},function(e,n){var o={},t=function(e){var n;return function(){return void 0===n&&(n=e.apply(this,arguments)),n}},r=t(function(){return/msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase())}),a=t(function(){return document.head||document.getElementsByTagName("head")[0]}),i=null,l=0,c=[];function s(e,n){for(var t=0;t<e.length;t++){var r=e[t],a=o[r.id];if(a){a.refs++;for(var i=0;i<a.parts.length;i++)a.parts[i](r.parts[i]);for(;i<r.parts.length;i++)a.parts.push(g(r.parts[i],n))}else{var l=[];for(i=0;i<r.parts.length;i++)l.push(g(r.parts[i],n));o[r.id]={id:r.id,refs:1,parts:l}}}}function f(e){for(var n=[],o={},t=0;t<e.length;t++){var r=e[t],a=r[0],i={css:r[1],media:r[2],sourceMap:r[3]};o[a]?o[a].parts.push(i):n.push(o[a]={id:a,parts:[i]})}return n}function p(e,n){var o=a(),t=c[c.length-1];if("top"===e.insertAt)t?t.nextSibling?o.insertBefore(n,t.nextSibling):o.appendChild(n):o.insertBefore(n,o.firstChild),c.push(n);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");o.appendChild(n)}}function u(e){e.parentNode.removeChild(e);var n=c.indexOf(e);n>=0&&c.splice(n,1)}function m(e){var n=document.createElement("style");return n.type="text/css",p(e,n),n}function g(e,n){var o,t,r;if(n.singleton){var a=l++;o=i||(i=m(n)),t=h.bind(null,o,a,!1),r=h.bind(null,o,a,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(e){var n=document.createElement("link");return n.rel="stylesheet",p(e,n),n}(n),t=function(e,n){var o=n.css,t=n.sourceMap;t&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */");var r=new Blob([o],{type:"text/css"}),a=e.href;e.href=URL.createObjectURL(r),a&&URL.revokeObjectURL(a)}.bind(null,o),r=function(){u(o),o.href&&URL.revokeObjectURL(o.href)}):(o=m(n),t=function(e,n){var o=n.css,t=n.media;if(t&&e.setAttribute("media",t),e.styleSheet)e.styleSheet.cssText=o;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(o))}}.bind(null,o),r=function(){u(o)});return t(e),function(n){if(n){if(n.css===e.css&&n.media===e.media&&n.sourceMap===e.sourceMap)return;t(e=n)}else r()}}e.exports=function(e,n){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");void 0===(n=n||{}).singleton&&(n.singleton=r()),void 0===n.insertAt&&(n.insertAt="bottom");var t=f(e);return s(t,n),function(e){for(var r=[],a=0;a<t.length;a++){var i=t[a];(l=o[i.id]).refs--,r.push(l)}for(e&&s(f(e),n),a=0;a<r.length;a++){var l;if(0===(l=r[a]).refs){for(var c=0;c<l.parts.length;c++)l.parts[c]();delete o[l.id]}}}};var d=function(){var e=[];return function(n,o){return e[n]=o,e.filter(Boolean).join("\n")}}();function h(e,n,o,t){var r=o?"":t.css;if(e.styleSheet)e.styleSheet.cssText=d(n,r);else{var a=document.createTextNode(r),i=e.childNodes;i[n]&&e.removeChild(i[n]),i.length?e.insertBefore(a,i[n]):e.appendChild(a)}}},function(e,n,o){e.exports=o(0)}]).default});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"layout":"layout--1NuH8","content":"content--37dfQ","status1":"status1--3YFdR","status2":"status2--TR-UJ","status3":"status3--2Q_X-","info":"info--LF0TR","code":"code--2iuFM","txt":"txt--1Sk0I"};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js